module.exports = __webpack_public_path__ + "static/img/guaduan.e17eab6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/guaduan.png
// module id = IfHg
// module chunks = 24